import React, { useEffect, useState } from 'react';
import { X } from 'react-feather';
import { Modal, ModalDimmerProps } from 'semantic-ui-react';
import styles from './styles/ConfettiModal.module.scss';
import { TriangleIcon } from 'components/svgs/TriangleIcon';
import { RectIcon } from 'components/svgs/RectIcon';
import { CircleIcon } from 'components/svgs/CircleIcon';
import { LongIcon } from 'components/svgs/LongIcon';

interface IProps {
  content: React.ReactNode;
  className?: string;
  heading?: React.ReactNode;
  modalClassName?: string;
  open?: boolean;
}

const dimmer: ModalDimmerProps = {
  className: styles.dimmer,
};

const ConfettiItems = ({ className }) => (
  <div className={classnames(styles.container, className)}>
    <TriangleIcon className={styles.triangle} />
    <TriangleIcon className={styles.triangle} />
    <TriangleIcon className={styles.triangle} />
    <TriangleIcon className={styles.triangle} />
    <TriangleIcon className={styles.triangle} />
    <RectIcon className={styles.rect} />
    <RectIcon className={styles.rect} />
    <RectIcon className={styles.rect} />
    <RectIcon className={styles.rect} />
    <RectIcon className={styles.rect} />
    <RectIcon className={styles.rect} />
    <RectIcon className={styles.rect} />
    <RectIcon className={styles.rect} />
    <RectIcon className={styles.rect} />
    <RectIcon className={styles.rect} />
    <RectIcon className={styles.rect} />
    <CircleIcon className={styles.circle} />
    <CircleIcon className={styles.circle} />
    <CircleIcon className={styles.circle} />
    <CircleIcon className={styles.circle} />
    <CircleIcon className={styles.circle} />
    <CircleIcon className={styles.circle} />
    <CircleIcon className={styles.circle} />
    <LongIcon className={styles.long} />
    <LongIcon className={styles.long} />
    <LongIcon className={styles.long} />
    <LongIcon className={styles.long} />
    <LongIcon className={styles.long} />
    <LongIcon className={styles.long} />
    <LongIcon className={styles.long} />
  </div>
);

const ConfettiModal = ({
  className,
  content,
  heading,
  open: showModal,
  modalClassName,
}: IProps) => {
  const [open, setOpen] = useState(showModal);

  const handleClose = () => setOpen(false);

  useEffect(() => {
    setOpen(showModal);
  }, [showModal]);

  return (
    open && (
      <>
        <ConfettiItems className={className} />
        <Modal
          open={open}
          className={classnames(styles.modal, modalClassName)}
          onClose={handleClose}
          size="mini"
          closeOnDimmerClick={true}
          closeIcon={false}
          dimmer={dimmer}
        >
          <Modal.Content className={styles.content}>
            <X className={styles.close} onClick={handleClose} />
            {heading && <div className={styles.heading}>{heading}</div>}
            <div className={styles.content}>{content}</div>
          </Modal.Content>
        </Modal>
      </>
    )
  );
};

export default React.memo(ConfettiModal);
